let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("j74fq"), load("lO0vk")]).then(() => parcelRequire('1Tjrn'));